import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const TIMELINE = [
  {
    title: 'Watch CORAA in Action',
    icon: '🤖',
    content: (
      <div className="space-y-4">
        {/* Matt typing bubble */}
        <motion.div initial={{opacity: 0, y: 10}} animate={{opacity: 1, y: 0}} transition={{delay: 0.1, duration: 0.6}} className="flex items-center gap-2">
          <span className="bg-white text-gray-900 px-3 py-1 rounded-full font-mono text-xs shadow">Matt…</span>
          <span className="animate-pulse text-gray-400">|</span>
        </motion.div>
        <motion.div initial={{opacity: 0, y: 10}} animate={{opacity: 1, y: 0}} transition={{delay: 0.7, duration: 0.6}} className="bg-gray-800/80 px-4 py-2 rounded-lg inline-block shadow text-sm text-white">
          “Need a volunteering event in San Jose for 60 people.”
        </motion.div>
        {/* CORAA bubbles */}
        <div className="flex flex-col gap-2 mt-2">
          <motion.div initial={{opacity: 0, x: 30}} animate={{opacity: 1, x: 0}} transition={{delay: 1.3, duration: 0.5}} className="bg-green-900/60 px-4 py-2 rounded-lg w-fit text-green-200 shadow">
            Scanning NPOs…
          </motion.div>
          <motion.div initial={{opacity: 0, x: 30}} animate={{opacity: 1, x: 0}} transition={{delay: 1.8, duration: 0.5}} className="bg-green-900/60 px-4 py-2 rounded-lg w-fit text-green-200 shadow">
            Receiving Quotes…
          </motion.div>
          <motion.div initial={{opacity: 0, x: 30}} animate={{opacity: 1, x: 0}} transition={{delay: 2.3, duration: 0.5}} className="bg-green-900/60 px-4 py-2 rounded-lg w-fit text-green-200 shadow">
            Top 3 options ready. Want to confirm?
          </motion.div>
        </div>
      
      </div>
    ),
  },
  {
    title: 'CORAA Learns from You',
    icon: '🧠',
    content: (
      <div className="space-y-4">
        <div className="flex flex-col sm:flex-row gap-2">
          <motion.div initial={{opacity:0, y: 10}} animate={{opacity:1, y:0}} transition={{delay:0.2}} className="bg-gray-900/70 px-3 py-2 rounded-md shadow flex items-center gap-2">
            <span className="font-semibold text-green-300">Budget:</span>
            <span className="bg-green-900/50 px-2 py-0.5 rounded">{'$1000'}</span>
          </motion.div>
          <motion.div initial={{opacity:0, y: 10}} animate={{opacity:1, y:0}} transition={{delay:0.5}} className="bg-gray-900/70 px-3 py-2 rounded-md shadow flex items-center gap-2">
            <span className="font-semibold text-green-300">Theme:</span>
            <span className="bg-green-900/50 px-2 py-0.5 rounded">Environment</span>
          </motion.div>
          <motion.div initial={{opacity:0, y: 10}} animate={{opacity:1, y:0}} transition={{delay:0.8}} className="bg-gray-900/70 px-3 py-2 rounded-md shadow flex items-center gap-2">
            <span className="font-semibold text-green-300">Partner:</span>
            <span className="bg-green-900/50 px-2 py-0.5 rounded">ABC Foundation</span>
          </motion.div>
        </div>
        <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{delay:1.2}} className="text-green-400 text-xs font-semibold mt-2">
          Preferences saved <span role="img" aria-label="check"></span>
        </motion.div>
      </div>
    ),
  },
  {
    title: 'Talk to CORAA. Live Interactive Session',
    icon: '💬',
    content: (
      <div className="space-y-4">
        <motion.div initial={{opacity:0, x:-20}} animate={{opacity:1, x:0}} transition={{delay:0.2}} className="flex items-center gap-2">
          <span className="text-lg"></span>
          <span className="bg-white text-gray-900 px-3 py-1 rounded-full font-mono text-xs shadow">What’s available for Pride Month next week?</span>
        </motion.div>
        <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{delay:0.7}} className="flex items-center gap-2">
          <span className="bg-green-900/60 px-4 py-2 rounded-lg w-fit text-green-200 shadow animate-pulse">CORAA responding</span>
        </motion.div>
        <motion.div initial={{opacity:0}} animate={{opacity:1}} transition={{delay:1.2}} className="flex gap-3 mt-2">
          {[1,2,3].map(i => (
            <motion.div key={i} whileHover={{scale:1.04}} className="bg-gray-900/80 rounded-xl px-4 py-3 shadow text-white flex flex-col items-center">
              <div className="font-semibold mb-1">Virtual option {i}</div>
              <div className="text-xs text-green-300 mb-2">${200 + i*20}</div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    ),
  },
  {
    title: 'Post-Event Impact Storytelling, with CORAA',
    icon: '✨',
    content: (
      <div className="space-y-4">
        <motion.div initial={{scale:0.95, opacity:0}} animate={{scale:1, opacity:1}} transition={{delay:0.2}} className="bg-gray-900/80 rounded-xl p-4 shadow flex flex-col gap-2 items-center">
          <div className="flex gap-4">
            <span className="flex flex-col items-center"><span className="text-2xl"></span><span className="text-xs text-green-200">82 Volunteers</span></span>
            <span className="flex flex-col items-center"><span className="text-2xl"></span><span className="text-xs text-green-200">520 saplings planted</span></span>
            <span className="flex flex-col items-center"><span className="text-2xl"></span><span className="text-xs text-green-200">Email sent </span></span>
          </div>
          <div className="w-full bg-green-900/40 rounded-full h-2 mt-3 overflow-hidden">
            <motion.div initial={{width:0}} animate={{width:'100%'}} transition={{delay:0.7, duration:1.2}} className="bg-green-400 h-2 rounded-full" />
          </div>
          <div className="text-green-300 text-xs font-semibold mt-2">Impact Story Ready</div>
        </motion.div>
      </div>
    ),
  },
  {
    title: 'What’s Next',
    icon: '🚀',
    content: (
      <div className="space-y-4">
        <div className="flex gap-3">
          {[
            {icon:'',label:'Multilingual AI'},
            {icon:'',label:'Impact Benchmarking'},
            {icon:'',label:'Slack + Teams Integration'}
          ].map((item, idx) => (
            <motion.div key={item.label} initial={{filter:'blur(6px)', opacity:0.5}} animate={{filter:'blur(0px)', opacity:1}} transition={{delay:0.5+idx*0.5, duration:0.7}} className="bg-gray-900/80 rounded-xl px-4 py-6 shadow flex flex-col items-center">
              <span className="text-3xl mb-2">{item.icon}</span>
              <span className="text-green-200 text-sm font-semibold text-center">{item.label}</span>
            </motion.div>
          ))}
        </div>
        <motion.div initial={{opacity:0, scale:0.98}} animate={{opacity:1, scale:1}} transition={{delay:2.2}} className="mt-4 text-center">
          <span className="inline-block bg-green-700/90 text-white px-4 py-2 rounded-full font-semibold shadow-lg animate-pulse cursor-pointer">
            You're just getting started 
          </span>
        </motion.div>
      </div>
    ),
  },
];

function TypingBubble({ text }: { text: string }) {
  const [display, setDisplay] = React.useState('');
  React.useEffect(() => {
    setDisplay('');
    let i = 0;
    const interval = setInterval(() => {
      setDisplay(text.slice(0, i + 1));
      i++;
      if (i === text.length) clearInterval(interval);
    }, 45);
    return () => clearInterval(interval);
  }, [text]);
  return (
    <span className="bg-gray-800/70 text-green-100 px-3 py-1 rounded-2xl font-mono tracking-tight shadow-inner border border-green-700/30 animate-pulse-in">
      {display}
      <span className="inline-block w-1 h-3 ml-1 bg-green-300 animate-blink align-middle"></span>
    </span>
  );
}

function Dropdown({ label }: { label: string }) {
  const [open, setOpen] = React.useState(false);
  React.useEffect(() => {
    const timer = setTimeout(() => setOpen(true), 350);
    return () => clearTimeout(timer);
  }, []);
  return (
    <motion.div initial={{ scale: 0.9, opacity: 0 }} animate={{ scale: open ? 1 : 0.9, opacity: open ? 1 : 0 }} transition={{ duration: 0.4 }} className="relative">
      <button className="bg-green-900/30 border border-green-700/30 text-green-200 px-4 py-1 rounded-lg shadow-sm font-semibold text-xs">
        {label}
      </button>
      {open && (
        <motion.div initial={{ opacity: 0, y: -5 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }} className="absolute left-0 mt-2 w-32 bg-green-950/90 border border-green-700/30 rounded-lg p-2 text-xs text-green-100 shadow-xl z-10">
          <div className="py-1">Sample Option 1</div>
          <div className="py-1">Sample Option 2</div>
        </motion.div>
      )}
    </motion.div>
  );
}

function RoadmapCard({ label }: { label: string }) {
  return (
    <motion.div initial={{ opacity: 0, y: 8 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }} className="bg-green-900/30 border border-green-700/30 rounded-lg px-4 py-2 text-green-200 text-xs font-semibold shadow">
      {label}
    </motion.div>
  );
}

function LiveRevealAgenda() {
  return (
    <section className="py-20 bg-gradient-to-b from-black to-gray-900 relative overflow-hidden">
      <div className="max-w-3xl mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10 text-center">
          <span className="text-green-400">Live Reveal</span> Agenda
        </h2>
        <div className="relative flex">
          {/* Timeline vertical line */}
          <div className="absolute left-6 top-0 bottom-0 w-1 bg-gradient-to-b from-green-400/80 to-green-800/10 rounded-full z-0"></div>
          <div className="flex flex-col gap-16 w-full ml-10">
            {TIMELINE.map((step, idx) => (
              <motion.div
                key={step.title}
                initial={{ opacity: 0, y: 60 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-120px' }}
                transition={{ duration: 0.7, delay: idx * 0.1 }}
                className="relative flex gap-6 items-start"
              >
                {/* Timeline node */}
                <div className="z-10">
                  <span className="w-14 h-14 rounded-full bg-gradient-to-tr from-green-400 via-green-500 to-green-700 flex items-center justify-center text-3xl font-bold shadow-xl border-4 border-green-300/40 text-white">
                    {step.icon}
                  </span>
                  {idx < TIMELINE.length - 1 && (
                    <span className="block w-1 h-16 mx-auto bg-green-700/30 rounded-full mt-1"></span>
                  )}
                </div>
                {/* Card */}
                <div className="bg-[#101718] border border-green-700/20 rounded-2xl px-8 py-6 shadow-xl w-full">
                  <h3 className="text-lg font-semibold text-green-200 mb-2 tracking-tight">
                    {step.title}
                  </h3>
                  <div>{step.content}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LiveRevealAgenda;
